import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-entry-guide': 'https://readdy.ai/api/search-image?query=A%20modern%20clean%20digital%20illustration%20of%20a%20secure%20web%20browser%20window%20showing%20a%20platform%20portal%20entrance%20with%20a%20glowing%20entry%20gate%20symbol%2C%20warm%20orange%20and%20teal%20accent%20colors%2C%20minimalist%20flat%20design%20style%2C%20soft%20gradient%20background%20in%20light%20cream%20tones%2C%20abstract%20geometric%20shapes%20representing%20connectivity%20and%20security&width=800&height=500&seq=thumb-entry-guide&orientation=landscape',
  'article-registration': 'https://readdy.ai/api/search-image?query=A%20clean%20and%20modern%20digital%20illustration%20of%20a%20user%20registration%20interface%20on%20a%20laptop%20screen%2C%20showing%20a%20friendly%20signup%20form%20with%20soft%20warm%20lighting%2C%20minimalist%20design%20with%20orange%20and%20cream%20tones%2C%20welcoming%20atmosphere%2C%20abstract%20user%20avatar%20icon&width=800&height=500&seq=thumb-registration&orientation=landscape',
  'article-features': 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20illustration%20showcasing%20multiple%20service%20platform%20features%20as%20interconnected%20floating%20cards%20with%20icons%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20minimalist%20flat%20design%2C%20light%20cream%20background&width=800&height=500&seq=thumb-features&orientation=landscape',
  'article-security': 'https://readdy.ai/api/search-image?query=A%20modern%20cybersecurity%20themed%20digital%20illustration%20showing%20a%20shield%20icon%20protecting%20digital%20assets%2C%20warm%20dark%20background%20with%20orange%20and%20teal%20accent%20lighting%2C%20minimalist%20flat%20design&width=800&height=500&seq=thumb-security&orientation=landscape',
  'article-update': 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20illustration%20showing%20a%20platform%20update%20announcement%20with%20glowing%20notification%20cards%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20minimalist%20flat%20design%2C%20abstract%20upgrade%20symbols&width=800&height=500&seq=thumb-update&orientation=landscape',
  'article-comparison': 'https://readdy.ai/api/search-image?query=A%20modern%20comparison%20chart%20illustration%20showing%20multiple%20platform%20feature%20cards%20side%20by%20side%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20minimalist%20flat%20design%2C%20clean%20bar%20chart&width=800&height=500&seq=thumb-comparison&orientation=landscape',
};

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" aria-labelledby="articles-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 id="articles-heading" className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              最新文章与指南
            </h2>
            <p className="text-sm text-foreground-600">为您精选 91.cc 相关的优质内容</p>
          </div>
          <Link
            to="/category/guide"
            className="inline-flex items-center text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-features']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-block px-2.5 py-0.5 text-xs font-medium rounded-full bg-accent-100 text-accent-700">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishedAt}</span>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-500">阅读 {article.readTime} 分钟</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}